// The one container every page sits in (docs/project_design/webapp.md §3).
//
// `max-w-5xl` is the whole site's content width, text pages and card grids
// alike. One width means every page is centred with equal gutters AND starts at
// the same x — the two pull apart the moment a page picks its own width, which
// is what a nested reading column did here before: aligned left edges, dead band
// down the right of every article.
//
// The trade at this width is line length: ~130 characters at 16px. The article
// body answers it with `lg:prose-lg` (18px type on wide screens) rather than by
// narrowing the column, so the page stays balanced.
//
// Exceptions, both deliberate: `/` (the portfolio is light and owns its own
// layout) and `/signin` (a centred dialog, not a page of content).

// `wide` is the one sanctioned departure, added for /graph: a page whose content
// is two panes side by side — a drawing and the node it selects — rather than a
// column of prose. The reading-width argument does not apply, because neither
// pane is a reading column. Every other page stays at max-w-5xl; this is not a
// general opt-out.
//
// The cap is in px, not rem, and that is deliberate. Every other width on the
// site is in rem, so a browser whose root font is 12px silently renders them at
// 75% — max-w-7xl came out as 960px rather than 1280px, and the two panes were
// each squeezed by a setting that has nothing to do with layout. A px cap gives
// both panes the window they can actually see.

export default function PageShell({ children, className = "", wide = false }) {
  return (
    <div className={`dark-page min-h-screen ${className}`}>
      <div
        className={`mx-auto px-4 py-12 sm:px-6 ${
          wide ? "max-w-[1600px]" : "max-w-5xl"
        }`}
      >
        {children}
      </div>
    </div>
  );
}
